import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getCurrentLanguage } from '../web-tools/i18n/utils/lang';
import { getRequest } from './../web-tools/utils/util';

const langEn = require('./../translationVooV/pc/locales/en/translation');
const langRu = require('./../translationVooV/pc/locales/ru/translation');
const langZhCN = require('./../translationVooV/pc/locales/zh-CN/translation');
const langZhTW = require('./../translationVooV/pc/locales/zh-TW/translation');

const resources = {
  en: {
    translation: langEn,
  },
  ru: {
    translation: langRu,
  },
  'zh-CN': {
    translation: langZhCN,
  },
  'zh-TW': {
    translation: langZhTW,
  },
};

const IS_I18N = process.env.IS_I18N === 'true';
const IS_DEVELOP_ENV = process.env.NODE_ENV === 'development';

const currentLang = IS_I18N ? getCurrentLanguage() : 'zh-CN';

// ls中有效的存储语言，也是词典当前支持的语言
const localStorageLangs = ['zh-CN', 'zh-TW', 'en'];
// navigator中有效的中文缩写
const validCnLangNavArr = ['zh-CN', 'zh-cn'];
// navigator中有效的中文繁体缩写
const validTwLangNavArr = ['zh-TW', 'zh-HK', 'zh-tw', 'zh-hk'];

// 初始化 i18n
function initI18n() {
  const lng = initLng();
  i18n.use(initReactI18next).init(
    {
      lng, // language to use (overrides language detection)
      fallbackLng: IS_I18N ? 'en' : 'zh-CN', // language to use if translations in user language are not available
      load: 'currentOnly', // only load current language code
      debug: !!IS_DEVELOP_ENV,
      interpolation: {
        escapeValue: false,
      },
      resources,
      keySeparator: false,
    },
    (err) => {
      console.log('load i18nxet error......', err);
    }
  );
  i18n.on('loaded', (loaded) => {
    console.log('loaded', loaded);
  });
  i18n.on('failedLoading', (lng, ns, msg) => {
    console.log('failedLoading', lng, ns, msg);
  });
}

/**
 * 数组中是否支持传入的语言
 * @param {*} langArr 参考的数组
 * @param {*} lang 需要校验的语言
 */
function isSupportLang(langArr, lang) {
  if (langArr.indexOf(lang) >= 0) {
    return true;
  }
  return false;
}

/**
 * 初始化腾讯会议语言环境， voov 沿用多语言配置， 浏览器地址语言和 local 是一个，voov 需要借用会议域名做转发需要把语言放浏览器
 * 1， 判断浏览器地址是否带语言
 * 2， 判断是否存在本地语言
 */
function initLng() {
  let lang = currentLang;

  const locale = getRequest('locale');
  if (locale) {
    lang = locale;
    return lang;
  }

  let support = isSupportLang(
    localStorageLangs,
    localStorage.getItem('language')
  );
  if (support) {
    lang = localStorage.getItem('language');
    return lang;
  }

  support = isSupportLang(validCnLangNavArr, navigator.language);
  if (support) {
    // eslint-disable-next-line prefer-destructuring
    lang = localStorageLangs[0];
    localStorage.setItem('language', lang);
    return lang;
  }
  // tip: 会议繁体显示中文， voov 繁体显示英文
  support = isSupportLang(validTwLangNavArr, navigator.language);
  if (support) {
    // eslint-disable-next-line prefer-destructuring
    lang = IS_I18N ? 'en' : localStorageLangs[0];
    localStorage.setItem('language', lang);
    return lang;
  }
  if (
    navigator.language &&
    navigator.language.toLowerCase().indexOf('zh') >= 0
  ) {
    lang = localStorageLangs[0];
    localStorage.setItem('language', lang);
    return lang;
  }
  if (navigator.language) {
    // eslint-disable-next-line prefer-destructuring
    lang = localStorageLangs[2];
  }
  localStorage.setItem('language', lang);
  return lang;
}

// 初始化不同环境下页面的初始配置
function initPageEnv() {
  console.log('>>> process.env: ', process.env);
  // 设置 html 的 env 属性，国际版为 env="i18n" 国内版为 env="cn"
  document.documentElement.setAttribute('env', IS_I18N ? 'i18n' : 'cn');
  document.documentElement.setAttribute(
    'lang',
    (!IS_I18N && localStorage.getItem('language')) || currentLang
  );
}

initI18n();
initPageEnv();
// eslint-disable-next-line no-underscore-dangle
window._i18n = i18n;

export default i18n;
export const t = i18n.t.bind(i18n);
